module.exports = __webpack_public_path__ + "static/media/ETH-USDT.235693a6.png";